import { useState } from 'react';
import Loader from './shared/Loader';
import DownloadIcon from '@mui/icons-material/Download';
import CloseIcon from '@mui/icons-material/Close';

const ImagePreviewModal = ({ src, onClose, onDownload }) => {
  const [loading, setLoading] = useState(true);

  if (!src) return null;

  return (
    <div onClick={onClose} style={styles.overlay}>
      <div onClick={(e) => e.stopPropagation()} style={styles.container}>
        {!loading && (
          <div style={styles.actionContainer}>
            {onDownload && (
              <div onClick={onDownload} style={styles.actionButton} title="Download">
                <DownloadIcon sx={styles.downloadIcon} />
              </div>
            )}
            <div onClick={onClose} style={styles.actionButton} title="Close">
              <CloseIcon sx={styles.closeIcon} />
            </div>
          </div>
        )}

        <img
          src={src}
          alt="Preview"
          style={{
            ...styles.image,
            ...(loading ? styles.imageHidden : {})
          }}
          onLoad={() => setLoading(false)}
        />

        {loading && (
          <div style={styles.loaderContainer}>
            <Loader />
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.85)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999999999,
    padding: 24
  },
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '100%',
    maxHeight: '100%'
  },
  image: {
    maxWidth: '100%',
    maxHeight: '90vh',
    borderRadius: 12
  },
  imageHidden: {
    display: 'none'
  },
  loaderContainer: {
    padding: 40
  },
  actionContainer: {
    position: 'absolute',
    top: -52,
    right: 0,
    display: 'flex',
    gap: 12,
    zIndex: 10
  },
  actionButton: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    backdropFilter: 'blur(4px)'
  },
  downloadIcon: {
    fontSize: 20,
    color: 'white'
  },
  closeIcon: {
    fontSize: 22,
    color: 'white'
  }
};

export default ImagePreviewModal;
